import { Action } from 'common/interfaces/root';
import { publishersSettingsActionTypes as T } from '../actions';

const initState: PublishersSettingsModule.IntegrationsSettingsStore = {
  loading: true,
  error: null,
  data: null,
};

export default (
  state: PublishersSettingsModule.IntegrationsSettingsStore = initState,
  { type, payload }: Action
): PublishersSettingsModule.IntegrationsSettingsStore => {
  switch (type) {
    case T.GET_INTEGRATIONS_LIST:
      return { ...state, loading: true };

    case T.GET_INTEGRATIONS_LIST_SUCCESS:
      return { ...state, loading: false, data: payload };

    case T.GET_INTEGRATIONS_LIST_ERROR:
      return { ...state, loading: false, error: payload };

    default:
      return state;
  }
};
